import React from 'react';

import PropTypes from 'prop-types';

import IconStyled, { IconContainer } from './styles';

import icons from '~/assets/icons';
import theme from '~/styles/theme';

const IconExporter = (props) => {
  const { margin, name, size, ...rest } = props;
  const { color } = props;
  if (!name) {
    return null;
  }
  const Icon = icons && icons[name.toLowerCase()];
  let otherProps = { ...rest };
  if (color) {
    let fill = null;
    if (
      ['PRIMARY', 'SECONDARY', 'DANGER'].indexOf(color.toUpperCase()) !== -1
    ) {
      fill = theme.palette[color].main;
    }
    otherProps = {
      ...rest,
      width: size,
      height: size,
      fill: fill || theme.palette[color],
      margin,
    };
  }
  return (
    <IconStyled {...otherProps}>
      <IconContainer {...otherProps}>
        <Icon {...otherProps} />
      </IconContainer>
    </IconStyled>
  );
};

IconExporter.propTypes = {
  name: PropTypes.oneOfType([
    PropTypes.oneOf([Object.keys(icons)]),
    PropTypes.string,
    PropTypes.object,
  ]),
  color: PropTypes.oneOf([...Object.keys(theme.palette), '']),
  margin: PropTypes.string,
  size: PropTypes.string,
  rotate: PropTypes.string,
};

IconExporter.defaultProps = {
  color: 'gray4',
  name: icons.prescription,
  rotate: '0deg',
  size: '50px',
  margin: '0px',
};

export default IconExporter;
